import { render, staticRenderFns } from "./UsersTableItem.vue?vue&type=template&id=75d01e3c&scoped=true&"
import script from "./UsersTableItem.vue?vue&type=script&lang=js&"
export * from "./UsersTableItem.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableItem.vue?vue&type=style&index=0&id=75d01e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d01e3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
